import * as React from 'react'

function IconSocial(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 28c7.18 0 13-5.82 13-13S22.18 2 15 2 2 7.82 2 15s5.82 13 13 13zM15 2v26M2 15h26"
        stroke="#F4BA27"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M15 28c3.866 0 7-5.82 7-13S18.866 2 15 2 8 7.82 8 15s3.134 13 7 13z"
        stroke="#F4BA27"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconSocial
